//export const API_URL: string = 'http://localhost:3320/api';
//export const API_URL: string = 'https://rdb.pesa.solutions/api';
export const API_URL: string = 'https://db.decawinrace.com/api';
//export const STK_API_URL: string = 'http://127.0.0.1:14000/api/proxy';
//export const STK_API_URL: string = 'https://rproxy.pesa.solutions/api/proxy';
export const STK_API_URL: string = 'https://rproxy.decawinrace.com/api/proxy';
//export const API_URL: string = 'http://localhost:3300/api';
export const LOGIN_URL: string = `${API_URL}/appLogin`;
export const USERS_URL: string = `${API_URL}/users`;
export const WITHDRAW_URL: string = `${API_URL}/withdrawalRequest`;
export const STK_API: string = `${STK_API_URL}/stkRequest`;